import playersFile from '../../content/places/arenal/players.json'
import backpackerJourney from '../../content/places/arenal/journeys/backpacker-adventure.json'
import coupleJourney from '../../content/places/arenal/journeys/couple-golden-hour.json'
import familyJourney from '../../content/places/arenal/journeys/family-discovery.json'
import groupJourney from '../../content/places/arenal/journeys/group-highlights.json'
import type { Hotspot, Journey, PlayerProfile } from '../types'

const journeys = [
  backpackerJourney,
  coupleJourney,
  familyJourney,
  groupJourney,
] as Journey[]

export function loadPlay(): {
  players: PlayerProfile[]
  journeys: Journey[]
} {
  return {
    players: playersFile.players as PlayerProfile[],
    journeys,
  }
}

export function resolveJourneyStops(
  journey: Journey,
  hotspots: Hotspot[],
): Hotspot[] {
  const byId = new Map(hotspots.map((hotspot) => [hotspot.id, hotspot]))
  return journey.stops.flatMap(({ hotspotId }) => {
    const hotspot = byId.get(hotspotId)
    return hotspot ? [hotspot] : []
  })
}
